import {
  ADD_FAVOURITE_INITIATIVE,
  ADD_FAVOURITE_INITIATIVE_SUCCESS,
  FETCH_INITIATIVE,
  FETCH_INITIATIVE_SUCCESS,
  FETCH_ALL_INITIATIVE,
  FETCH_ALL_INITIATIVE_SUCCESS,
  FILTER_INITIATIVE,
  GET_ALL_INITIATIVE,
  GET_UNSELECTED_ALL_INITIATIVE,
  HANDLE_INITIATIVE_REQUEST_CLOSE,
  HIDE_INITIATIVE_LOADER,
  SHOW_INITIATIVE_LOADER,
  ON_ADD_INITIATIVE,
  ON_EDIT_INITIATIVE,
  SET_INITIATIVE,
  ON_ALL_INITIATIVE_SELECT,
  ON_INITIATIVE_CLOSE,
  ON_INITIATIVE_SELECT,
  ON_DELETE_INITIATIVE,
  ON_DELETE_INITIATIVE_SUCCESS,
  ON_FILTER_SELECTED_INITIATIVE,
  ON_FILTER_INITIATIVE_OPTION_SELECT,
  ON_SAVE_INITIATIVE,
  ON_SAVE_INITIATIVE_SUCCESS,
  ON_TOGGLE_INITIATIVE_DRAWER,
  SHOW_INITIATIVE_MESSAGE,
  UPDATE_SEARCH_INITIATIVE,
  ON_FETCH_SELECT_PRODUCT_DATA,
  ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS,
  ON_INITIATIVE_PRODUCT_UPDATE,
} from 'constants/ActionTypes';

export const onInitiativeProductUpdate = () => {
  return {
      type: ON_INITIATIVE_PRODUCT_UPDATE,
  };
};
export const onFetchSelectProductData = () => {
  return {
      type: ON_FETCH_SELECT_PRODUCT_DATA,
  };
};
export const onFetchSelectProductDataSuccess = (payload) => {
  return {
      type: ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS,
      payload
  };
};
export const setInitiative = (payload) => {
  return {
      type: SET_INITIATIVE,
      payload
  };
};
export const fetchInitiative = (payload) => {
  return {
      type: FETCH_INITIATIVE,
      payload
  };
};
export const fetchInitiativeSuccess = (payload) => {
  return {
      type: FETCH_INITIATIVE_SUCCESS,
      payload
  };
};
export const fetchInitiatives = () => {
  return {
      type: FETCH_ALL_INITIATIVE
  };
};
export const fetchInitiativesSuccess = (payload) => {
  return {
      type: FETCH_ALL_INITIATIVE_SUCCESS,
      payload
  };
};
export const showInitiativeMessage = (message) => {
  return {
      type: SHOW_INITIATIVE_MESSAGE,
      payload: message
  };
};
export const addFavouriteInitiative = (payload) => {
  return {
      type: ADD_FAVOURITE_INITIATIVE,
      payload
  };
};
export const addFavouriteInitiativeSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_INITIATIVE_SUCCESS,
      payload
  };
};
export const onInitiativeSelect = (payload) => {
  return {
      type: ON_INITIATIVE_SELECT,
      payload
  };
};
export const onAddInitiative = () => {
  return {
      type: ON_ADD_INITIATIVE,
  };
};
export const onEditInitiative = (payload) => {
  return {
      type: ON_EDIT_INITIATIVE,
      payload
  };
};
export const onInitiativeClose = () => {
  return {
      type: ON_INITIATIVE_CLOSE,
  };
};
export const onFilterInitiativeOptionSelect = (payload) => {
  return {
      type: ON_FILTER_INITIATIVE_OPTION_SELECT,
      payload
  };
};
export const onSaveInitiative = (payload) => {
  return {
      type: ON_SAVE_INITIATIVE,
      payload
  };
};
export const onSaveInitiativeSuccess = (data) => {
  return {
      type: ON_SAVE_INITIATIVE_SUCCESS,
      payload: data
  };
};
export const onDeleteInitiative = (payload) => {
  return {
      type: ON_DELETE_INITIATIVE,
      payload
  };
};
export const onDeleteInitiativeSuccess = (payload) => {
  return {
      type: ON_DELETE_INITIATIVE_SUCCESS,
      payload
  };
};
export const onFilterSelectedInitiative = () => {
  return {
      type: ON_FILTER_SELECTED_INITIATIVE,
      payload: ''
  };
};
export const filterInitiative = (payload) => {
  return {
      type: FILTER_INITIATIVE,
      payload
  };
};
export const getAllInitiative = () => {
  return {
      type: GET_ALL_INITIATIVE,
      payload: ''
  };
};
export const getUnselectedAllInitiative = () => {
  return {
      type: GET_UNSELECTED_ALL_INITIATIVE,
      payload: ''
  };
};
export const onAllInitiativeSelect = () => {
  return {
      type: ON_ALL_INITIATIVE_SELECT,
      payload: ''
  };
};
export const updateSearchInitiative = (payload) => {
  return {
      type: UPDATE_SEARCH_INITIATIVE,
      payload
  };
};
export const onToggleInitiativeDrawer = () => {
  return {
      type: ON_TOGGLE_INITIATIVE_DRAWER,
  };
};
export const handleInitiativeRequestClose = () => {
  return {
      type: HANDLE_INITIATIVE_REQUEST_CLOSE,
  };
};
export const showInitiativeLoader = () => {
  return {
      type: SHOW_INITIATIVE_LOADER,
  };
};
export const hideInitiativeLoader = () => {
  return {
      type: HIDE_INITIATIVE_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/initiative.js